import React from 'react';
import { connect} from 'react-redux';
import css from '../styles/home-hero.css';

const { Component } = React;

class Hero extends Component {
  render() {
    return (
      <section className="home-hero">
        <heading className="home-hero__heading">
          <ul className="home-hero__slogan">
            <li>Experienced</li><li>Reliable</li><li>Practical</li>
          </ul>
          <h1 className="home-hero__heading-text">Ben Meek</h1>
          <em className="home-hero__subheading-text">attorney at law</em>
        </heading>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

let HeroContainer = connect(mapStateToProps, mapDispatchToProps)(Hero);

export { Hero, HeroContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-hero.js